

export interface IGetCaptchaInfo {
  dataSiteKey: string;
}
export class GetCaptchaInfo {
  constructor(public dataSiteKey: string) { }

  public static fromJson(request: IGetCaptchaInfo): GetCaptchaInfo {
    return new this(request.dataSiteKey);
  }
}
